import { defineStore } from 'pinia'
import axios from 'axios'

const API_URL = '/api'

export const useGroupStore = defineStore('group', {
  state: () => ({
    groups: [],
    loading: false,
    currentListId: null
  }),
  
  actions: {
    async fetchGroups(listId) {
      if (!listId) {
        this.groups = []
        return
      }
      
      this.loading = true
      this.currentListId = listId
      try {
        const response = await axios.get(`${API_URL}/packlists/${listId}/groups`)
        this.groups = response.data
      } catch (error) {
        console.error('Failed to fetch groups:', error)
        this.groups = []
      } finally {
        this.loading = false
      }
    },
    
    async createGroup(groupData) {
      try {
        const response = await axios.post(`${API_URL}/groups`, groupData)
        this.groups.push(response.data)
        return { success: true, group: response.data }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Failed to create group' 
        }
      }
    },
    
    async updateGroup(groupId, groupData) {
      try {
        const response = await axios.put(`${API_URL}/groups/${groupId}`, groupData)
        const index = this.groups.findIndex(g => g.id === groupId)
        if (index !== -1) {
          this.groups[index] = response.data
        }
        return { success: true, group: response.data }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Failed to update group' 
        }
      }
    },
    
    async deleteGroup(groupId) {
      try {
        await axios.delete(`${API_URL}/groups/${groupId}`)
        this.groups = this.groups.filter(g => g.id !== groupId)
        return { success: true }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Failed to delete group' 
        }
      }
    },
    
    async moveGroupUp(groupId) {
      try {
        await axios.put(`${API_URL}/groups/${groupId}/move-up`)
        // Refresh groups to reflect the new order
        if (this.currentListId) {
          await this.fetchGroups(this.currentListId)
        }
        return { success: true }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Failed to move group up' 
        }
      }
    },
    
    async moveGroupDown(groupId) {
      try {
        await axios.put(`${API_URL}/groups/${groupId}/move-down`)
        // Refresh groups to reflect the new order
        if (this.currentListId) {
          await this.fetchGroups(this.currentListId)
        }
        return { success: true }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Failed to move group down' 
        }
      }
    },
    
    async rearrangeGroups(packlistId, groupIds) {
      try {
        await axios.put(`${API_URL}/packlists/${packlistId}/groups/rearrange`, groupIds)
        // Refresh groups to reflect the new order
        if (this.currentListId) {
          await this.fetchGroups(this.currentListId)
        }
        return { success: true }
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.detail || 'Failed to rearrange groups' 
        }
      }
    },
    
    getGroupById(groupId) {
      return this.groups.find(g => g.id === groupId)
    },
    
    getGroupByName(name) {
      return this.groups.find(g => g.name === name)
    }
  }
})